import type { ReactNode } from 'react';
import type { AdminRolePermissions } from 'src/types/admin';

import { useMemo, useContext, createContext } from 'react';

export type AdminPermissionsContextValue = AdminRolePermissions & {
  refetch: () => void;
};

const AdminPermissionsContext = createContext<AdminPermissionsContextValue | null>(null);

type AdminPermissionsProviderProps = {
  permissions: AdminRolePermissions;
  refetch: () => void;
  children: ReactNode;
};

export function AdminPermissionsProvider({
  permissions,
  refetch,
  children,
}: AdminPermissionsProviderProps) {
  const value = useMemo<AdminPermissionsContextValue>(
    () => ({ ...permissions, refetch }),
    [permissions, refetch]
  );

  return (
    <AdminPermissionsContext.Provider value={value}>{children}</AdminPermissionsContext.Provider>
  );
}

export function useAdminPermissions(): AdminPermissionsContextValue {
  const context = useContext(AdminPermissionsContext);

  if (!context) {
    throw new Error(
      'useAdminPermissions must be used within AdminPermissionsProvider (wrap with PermissionBasedGuard)'
    );
  }

  return context;
}
